import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import { MaterialTextFieldComponentModel } from "../../models/components.model";
import * as Converter from "persian-currency-converter";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";

const PriceFeildComponent = (props: MaterialTextFieldComponentModel) => {
  /* test separator */
  const [valueInput, setValueInput] = React.useState(props.value);
  const addCommas = (num: any) =>
    num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const removeNonNumeric = (num: any) => num.toString().replace(/[^0-9]/g, "");
  let pricePersian: number;
  if (props.value) {
    pricePersian = removeNonNumeric(props.value);
  } else {
    pricePersian = props.value;
  }
  const [valueInput_P, setValueInput_P] = React.useState(pricePersian);
  const handelInput = (event: any) => {
    setValueInput(addCommas(removeNonNumeric(event.target.value)));
    // setValueInput_P(Math.round(removeNonNumeric(event.target.value) / 10));
    setValueInput_P(removeNonNumeric(event.target.value));
  };

  /* test separator */
  const jsonFile = useSelector((state: any) => state.style);

  return (
    <Box sx={{ marginBottom: "20px" }}>
      <TextField
        style={{
          marginRight: "0px",
          height: "40px",
          fontSize: "16px",
          boxShadow:
            "0 0px 1px 0 rgba(0, 0, 0, 0), 0 1px 1px 0 rgba(0, 0, 0, 0.2)",
          borderRadius: "3px",
        }}
        error={props.error}
        label={props.label}
        value={props.value == "" ? "" : valueInput}
        helperText={props.helperText}
        onChange={props.onChange}
        name={props.name}
        onInput={handelInput}
        type={props.type}
        id={props.id}
        variant="outlined"
        fullWidth
        color={jsonFile?.muiColor}
        onKeyDown={props.onKeyDown}
        onBlur={props.onBlur}
        onFocus={props.onFocus}
        autoFocus={props.autoFocus}
      />
      {props.showPersianWords == undefined || props.showPersianWords ? (
        props.error ? (
          <>
            {valueInput_P && (
              <>
                {/* <br />
              <br /> */}
                <span
                  className={`${!props.error ? "mTop10" : ""} colorTitle`}
                  style={{ fontSize: "10.3px" }}
                >
                  {Converter.convertToPersianWord(valueInput_P)} ریال{" "}
                </span>
              </>
            )}
          </>
        ) : (
          <>
            {valueInput_P && (
              <span
                className={`${!props.error ? "mTop10" : ""} colorTitle`}
                style={{ fontSize: "10.3px" }}
              >
                {Converter.convertToPersianWord(valueInput_P)} ریال{" "}
              </span>
            )}
          </>
        )
      ) : (
        <></>
      )}
    </Box>
  );
};

export default PriceFeildComponent;
